const UrlNotValid = () => {
  return (
    <div className="container m-auto text-center p-4">
      <div className="alert alert-danger" role="alert">
        This URL is not valid
      </div>
    </div>
  );
};

export default UrlNotValid;
